function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CancelOutlined } from "@mui/icons-material";
import { FormControl, FormGroup, FormLabel, IconButton, Stack } from "@mui/material";
import cn from "clsx";
import { FieldArray, useFormikContext } from "formik";
import { useCallback, useEffect, useId, useMemo } from "react";
import { Button } from "../Button";
import { FormField } from "./FormField";
export var FormListBuilder = function(props) {
    var formikCtx = useFormikContext();
    var addButtonId = useId();
    var listBuilderId = useId();
    var emptyRow = useMemo(function() {
        return props.fields.reduce(function(acc, field) {
            return _object_spread_props(_object_spread({}, acc), _define_property({}, field.name, ''));
        }, {});
    }, [
        props.fields
    ]);
    var isAddButtonDisabled = useMemo(function() {
        var _formikCtx_values_props_name;
        return !((_formikCtx_values_props_name = formikCtx.values[props.name]) === null || _formikCtx_values_props_name === void 0 ? void 0 : _formikCtx_values_props_name.length) || props.fields.every(function(field) {
            return !formikCtx.getFieldMeta("".concat(props.name, "[").concat(formikCtx.values[props.name].length - 1, "][").concat(field.name, "]")).value;
        }) || props.disabled || formikCtx.isSubmitting;
    }, [
        props.fields,
        formikCtx,
        props.disabled
    ]);
    var onRemove = useCallback(function(entryNumber) {
        if (formikCtx.values[props.name].length > 1) {
            formikCtx.setFieldValue(props.name, formikCtx.values[props.name].filter(function(_, index) {
                return index !== entryNumber;
            }));
            // prevents new fields from getting old index's touched value
            props.fields.forEach(function(field) {
                formikCtx.getFieldHelpers("".concat(props.name, "[").concat(entryNumber, "][").concat(field.name, "]")).setTouched(false);
            });
        } else {
            // only one entry, clear the row
            formikCtx.setFieldValue(props.name, [
                emptyRow
            ]);
            formikCtx.setFieldTouched(props.name, true);
        }
    }, [
        formikCtx,
        props.fields,
        props.name,
        emptyRow
    ]);
    var onRowAdd = useCallback(function() {
        // add a new row
        formikCtx.setFieldValue(props.name, _to_consumable_array(formikCtx.values[props.name]).concat([
            emptyRow
        ]));
        // set all fields in the new entry to touched
        props.fields.forEach(function(field) {
            formikCtx.getFieldHelpers("".concat(props.name, "[").concat(formikCtx.values[props.name].length, "][").concat(field.name, "]")).setTouched(true);
        });
    }, [
        formikCtx,
        props.fields,
        props.name,
        emptyRow
    ]);
    var onSubmit = useCallback(function(formikArrayHelper) {
        return function(e) {
            // this DOES NOT WORK if called on formikCtx.setValues
            formikArrayHelper.form.setValues(Object.fromEntries(Object.entries(formikArrayHelper.form.values).map(function(param) {
                var _param = _sliced_to_array(param, 2), name = _param[0], values = _param[1];
                return Array.isArray(values) ? [
                    name,
                    values.filter(function(c) {
                        return Object.values(c).filter(Boolean).length;
                    })
                ] : [
                    name,
                    values
                ];
            })));
            formikArrayHelper.form.handleSubmit(e);
        };
    }, [
        formikCtx
    ]);
    useEffect(function() {
        var _formikCtx_values_props_name;
        if (!((_formikCtx_values_props_name = formikCtx.values[props.name]) === null || _formikCtx_values_props_name === void 0 ? void 0 : _formikCtx_values_props_name.length)) {
            // force list to have one empty row so FormFields can show errors
            formikCtx.setFieldValue(props.name, [
                emptyRow
            ]);
        }
    }, [
        formikCtx,
        props.name,
        emptyRow
    ]);
    return /*#__PURE__*/ _jsx(FieldArray, {
        name: props.name,
        children: function(arrayHelpers) {
            var _arrayHelpers_form_values_props_name;
            // clear empty rows before Formik submits
            formikCtx.handleSubmit = onSubmit(arrayHelpers);
            return /*#__PURE__*/ _jsxs(FormControl, {
                className: cn('contents', props.className),
                "data-component": "listBuilder",
                "data-testid": props.name,
                disabled: props.disabled,
                error: !!(formikCtx.touched[props.name] && formikCtx.errors[props.name]),
                fullWidth: props.fullWidth,
                children: [
                    /*#__PURE__*/ _jsx(FormLabel, {
                        component: "legend",
                        "data-component": "listBuilderLegend",
                        "data-testid": props.label,
                        id: listBuilderId,
                        children: props.label
                    }),
                    /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ _jsx(FormGroup, {
                                "aria-describedby": addButtonId,
                                "aria-labelledby": listBuilderId,
                                children: /*#__PURE__*/ _jsx(Stack, {
                                    spacing: {
                                        md: 0,
                                        xs: 8
                                    },
                                    children: (((_arrayHelpers_form_values_props_name = arrayHelpers.form.values[props.name]) === null || _arrayHelpers_form_values_props_name === void 0 ? void 0 : _arrayHelpers_form_values_props_name.length) ? arrayHelpers.form.values[props.name] : [
                                        emptyRow
                                    ]).map(function(entry, rowIndex) {
                                        return /*#__PURE__*/ _jsxs(Stack, {
                                            "aria-describedby": "removeButton".concat(rowIndex),
                                            "aria-label": "".concat(props.label, " row ").concat(rowIndex + 1),
                                            direction: "row",
                                            justifyContent: {
                                                md: 'space-between',
                                                sm: 'start'
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsx(Stack, {
                                                    direction: {
                                                        md: 'row',
                                                        sm: 'column'
                                                    },
                                                    spacing: {
                                                        md: 3
                                                    },
                                                    children: props.fields.map(function(field) {
                                                        return /*#__PURE__*/ _jsx(FormField, {
                                                            disabled: arrayHelpers.form.isSubmitting || field.disabled || props.disabled,
                                                            format: field.format,
                                                            hideError: props.hideError,
                                                            label: field.label,
                                                            name: "".concat(props.name, "[").concat(rowIndex, "].").concat(field.name),
                                                            onChange: field.onChange,
                                                            placeholder: field.placeholder,
                                                            type: field.type || 'text'
                                                        }, "".concat(props.name, "[").concat(rowIndex, "].").concat(field.name));
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Stack, {
                                                    justifyContent: props.hideError ? 'end' : 'center',
                                                    children: /*#__PURE__*/ _jsx(IconButton, {
                                                        "aria-label": "Remove ".concat(props.label, " row ").concat(rowIndex + 1),
                                                        color: "primary",
                                                        disabled: arrayHelpers.form.isSubmitting || props.disabled,
                                                        id: "removeButton".concat(rowIndex),
                                                        onClick: function() {
                                                            return onRemove(rowIndex);
                                                        },
                                                        size: "large",
                                                        children: /*#__PURE__*/ _jsx(CancelOutlined, {})
                                                    })
                                                })
                                            ]
                                        }, "".concat(props.name, "[").concat(rowIndex, "]"));
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Stack, {
                                alignContent: "start",
                                direction: "row",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    "aria-label": "Add new row to ".concat(props.label),
                                    disabled: isAddButtonDisabled,
                                    id: addButtonId,
                                    onClick: onRowAdd,
                                    type: "button",
                                    variant: "outlined",
                                    children: "Add +"
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
};
FormListBuilder.displayName = 'FormListBuilder';

//# sourceMappingURL=FormListBuilder.js.map